// import * as firebase from "../../../firebase";
// import router from '../../../router'
import { getAuth, signInWithEmailAndPassword,signOut } from "firebase/auth";
const state = {
  userProfile_: {},
};

const mutations = {
  setUserProfile(state, val) {
    state.userProfile_ = val;
  },
  setPerformingRequest(state, val) {
    state.performingRequest = val;
  },
  setPosts(state, val) {
    state.posts = val;
  },
};

const actions = {
  async login({ dispatch }, form) {
    // sign user in
    // const { user } = await firebase.auth.signInWithEmailAndPassword(
    //   form.email,
    //   form.password
    // );

    // // console.log(user)
    // // fetch user profile and set in state
    // dispatch("fetchUserProfile", user);

    const auth = getAuth();
    signInWithEmailAndPassword(auth, form.email, form.password)
      .then((userCredential) => {
        // Signed in 
        const user = userCredential.user;
        console.log(user)
        dispatch("fetchUserProfile", user)
      
      })
      .catch((error) => {
        console.log(error.message)
        // const errorCode = error.code;
        // const errorMessage = error.message;
      });




  },

  async fetchUserProfile({ commit }, user) {
    // fetch user profile
    //    console.log(user)
    //  const userProfile = await fb.usersCollection.doc(user.uid).get()

    // set user profile in state
    commit("setUserProfile", user);

    // change route to dashboard
    //  if (router.currentRoute.path === '/login') {
    //    router.push('/')
    //  }
  },
  async logout({ commit }) {
    // log user out
    // await firebase.auth.signOut();
    const auth = getAuth();
    signOut(auth).then(() => {
      // Sign-out successful.
      commit("setUserProfile", {});
    }).catch((error) => {
      console.log(error.message)
      // An error happened.
    });
    
    // clear user data from state
    // commit("setUserProfile", {});

    // redirect to login view
    // router.push('/login')
  },
};

//  const mutations = {
// //
// };

export default {
  state,
  actions,
  mutations,
  // getters,
};
